import { useBeforeUnload } from '@exam-room/utils';
import { getSessionStorageItem, setSessionStorageItem } from '@shared/utils';
import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';

import { ExamPreviewSettingsProvider, type PreviewSettings } from '../../../providers';

import { getPreviewSettingsFromSearchParams } from './utils';

export default function ExamPreviewSettingsLayout({ children }: { children: React.ReactNode }) {
  const [searchParams] = useSearchParams();
  const [previewSettings, setPreviewSettings] = useState<PreviewSettings | undefined>();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const initialSettings = getPreviewSettingsFromSearchParams(searchParams);
    const sessionStoragePreviewSettings = getSessionStorageItem<PreviewSettings>('previewSettings');

    if (initialSettings) {
      setPreviewSettings(initialSettings);
      setSessionStorageItem<PreviewSettings>('previewSettings', initialSettings);
    } else if (sessionStoragePreviewSettings) {
      setPreviewSettings(sessionStoragePreviewSettings);
    }
    // Navigate to current path without query parameters
    navigate(location.pathname, { replace: true });
  }, []); // run once on mount

  useBeforeUnload();

  return (
    <ExamPreviewSettingsProvider initialSettings={previewSettings}>
      {children}
    </ExamPreviewSettingsProvider>
  );
}
